import { Link } from "react-router-dom";

const MenuMisc = (dropdownRef, closeDropdownMenu) => {
  const links = [
    {
      displayName: "Cutlery",
      linkTo: "/misc/cutlery",
    },
    {
      displayName: "Napkins",
      linkTo: "/misc/napkin",
    },
    {
      displayName: "Gloves",
      linkTo: "/misc/glove",
    },
    {
      displayName: "Foil & Film",
      linkTo: "/misc/foil",
    },
  ];

  return (
    <ul ref={dropdownRef}>
      {links.map((link, index) => {
        return (
          <li className="px-4 py-2 hover:bg-containx-beige">
            <Link
              to={link.linkTo}
              onClick={closeDropdownMenu}
              className="block"
              key={"misc-menu-" + index}
            >
              {link.displayName}
            </Link>
          </li>
        );
      })}
      <li className="px-4 py-2 hover:bg-containx-beige font-bold">
        <Link to="/misc" onClick={closeDropdownMenu} className="block">
          See All
        </Link>
      </li>
    </ul>
  );
};

export default MenuMisc;
